import "./AboutUs.module.css";
import Naglowek from "@/reusable_sections/Header";
import WhoWeAre from "./sections/WhoWeAre";
import OurTeamOverview from "./sections/OurTeamOverview";
import About from "./sections/About";
import Stopka from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <Naglowek />
      <WhoWeAre />
      <About />
      <OurTeamOverview />
      <Stopka />
    </div>;
}